import { useState, useEffect, type ReactNode } from 'react'
import { WifiOffIcon } from '@/shared/components/icons'
import { IconTile } from '@/shared/components/ui'

interface OfflineGateProps {
  children: ReactNode
}

export function OfflineGate({ children }: OfflineGateProps) {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  )

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (!isOnline) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 text-center">
        <IconTile tone="neutral">
          <WifiOffIcon className="h-6 w-6" aria-hidden="true" />
        </IconTile>
        <h1 className="mt-4 text-xl font-bold text-navy-900">You're offline</h1>
        <p className="mt-2 max-w-sm text-sm text-neutral-600">
          Internet connection is required to use PSN Connect. Please check your
          connection and try again.
        </p>
      </div>
    )
  }

  return children
}
